import { useContext } from "react";
import { MainContext } from "../../../../../MainContext";
import { convertToString } from "../../../Inputs/convert";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import Swal from "sweetalert2";
import { request } from "../../../../../request";
import { CurrencyIcon } from "../../../CurrencyIcons/CurrencyIcons";

interface TransactionProps {
    transaction: any;
    arr: any[];
    indexik: number;
    joined_transaction: any;
    getFilteredHistory: any;
}

export const Transaction = ({ transaction, arr, indexik, joined_transaction, getFilteredHistory }: TransactionProps) => {
    const { updateTransactions } = useContext(MainContext);

    const handleBoundableChange = async (id: string) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You are about to change the boundable status of this transaction.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
        });

        if (result.isConfirmed) {
            await request.post(`/transaction/change-to-be-bounded/${id}`);
            updateTransactions();
            getFilteredHistory();
        }
    };

    const split_bound = async (transaction: any) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You are about to split boundable transaction",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
        });
        if (result.isConfirmed) {
            await request.post(`/transaction/split-bound`, { transaction });
            updateTransactions();
            getFilteredHistory();
        }
    };

    const renderLabels = () =>
        transaction.labels.length > 0 && (
            <div className="labels">
                {transaction.labels.map((label: string, idx: number) => (
                    <div key={idx} className="label">
                        <img src="/img/user.png" alt="user" />
                        <p>{label}</p>
                    </div>
                ))}
            </div>
        );

    const renderPlaces = (places: any[], type: string) =>
        places.map((place, idx) => (
            <div key={idx} className="transaction-cell">
                <img className="transaction-icon" src={place.icon} alt="icon" />
                <div className="text-content">
                    <p>{place.name}</p>
                </div>
                {place.place.accountId && (
                    <div className="amounts">
                        <b>
                            {convertToString(place.amount)}
                            <CurrencyIcon className="icon" currency_name={place.currency_name} />
                        </b>
                        {type === "to" && <p style={{ width: "130px" }}>Added Rate: {place.commingAvg?.toFixed(2)}</p>}
                    </div>
                )}
            </div>
        ));
    return (
        <>
            <div className="transaction">
                {renderLabels()}

                <div className="transaction-path">
                    <div className="places from">{renderPlaces(transaction.from, "from")}</div>

                    <div className="arrow">{window.innerWidth <= 650 ? <ArrowDownwardIcon /> : <ArrowForwardIcon />}</div>

                    <div className="places to">{renderPlaces(transaction.to, "to")}</div>

                    {joined_transaction.transactions[0]?.toBeBounded && joined_transaction.transactions.length > 1 && <div className="transaction-cell">{transaction.date}</div>}

                    {joined_transaction.transactions.length === 1 && joined_transaction.transactions[0]?.toBeBounded && (
                        <div className="transaction-cell">
                            <label className="transaction-checkbox">
                                <p className="checkbox-label">Boundable:</p>
                                <input type="checkbox" className="hidden" onChange={() => handleBoundableChange(transaction.id)} />
                                <span className={`checkbox-span ${transaction.toBeBounded ? "checked" : ""}`}>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="checkbox-icon" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" clipRule="evenodd" />
                                    </svg>
                                </span>
                            </label>
                        </div>
                    )}
                    {joined_transaction.transactions[0]?.toBeBounded && joined_transaction.transactions.length > 1 && !joined_transaction.finished && (
                        <button className="transaction-cell split" onClick={() => split_bound({ _id: transaction.id, joined_transaction_id: joined_transaction._id })}>
                            Split
                        </button>
                    )}
                </div>
            </div>

            {joined_transaction.transactions[0]?.toBeBounded && joined_transaction.transactions.length > 1 && indexik !== arr.length - 1 && <hr />}
        </>
    );
};
